import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GCADASidebarModule } from '@GCADA/components';
import { GCADASharedModule } from '@GCADA/shared.module';

import { HomeVerticalLayoutComponent } from './home-vertical-layout.component';


@NgModule({
    declarations: [
        HomeVerticalLayoutComponent
    ],
    imports: [
        RouterModule,

        GCADASharedModule,
        GCADASidebarModule,

    ],
    exports: [
        HomeVerticalLayoutComponent
    ]
})
export class HomeVerticalLayoutModule {
}
